<template>
  <div class="px-5 py-5">

    <notifications position="top center" ></notifications>


    <div class="bg-white">
      <h2 class="font-bold text-center mb-5">Users ({{usersData.total}})</h2>
      <div class="flex flex-col space-y-8">
        <div class="flex flex-row mx-auto w-full xl:w-1/2 flex-wrap">
          <label for="searchTerm" class="sr-only">Type name or email to search</label>
          <input type="text" v-model="searchTerm" v-on:keyup.enter="search" id="searchTerm" class="w-auto flex-1 sm:text-sm focus:outline-none focus:ring-pink-500 focus:border-pink-500" placeholder="Name, Email, Address, User ID">

          <div class="flex mx-auto mt-3 xl:mt-0 xl:ml-3">
            <a @click="search"  href="#" class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium text-white bg-pink-500 hover:bg-pink-700 focus:outline-none  focus:ring-pink-200">
              Search
            </a>

            <div class="inline-flex shadow ml-3">
              <a @click="openFilterModal = true" href="#" class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium text-white bg-blue-500 hover:bg-blue-700 focus:outline-none  focus:ring-blue-200">
                Add User
              </a>
            </div>
          </div>
        </div>
<!--        <div class="mx-auto">-->
<!--          <a href="#" @click="download" class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium text-white bg-green-500 hover:bg-green-700 focus:outline-none  focus:ring-green-200">-->
<!--            Download Results-->
<!--          </a>-->
<!--        </div>-->


        <div class="xl:border border-gray-200">
          <div class="hidden xl:flex xl:flex-row px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray uppercase tracking-wider justify-between border-b border-gray-200">
            <div class="xl:pl-2 xl:w-1/12">ID</div>
            <div class="xl:w-2/12">Name</div>
            <div class="xl:w-2/12 xl:px-1">Email</div>
            <div class="xl:w-2/12 xl:px-1">Signed Up</div>
            <div class="xl:w-1/12">&nbsp;</div>
          </div>
          <div class="flex flex-col space-y-3 xl:space-y-0">

            <div v-for="user in users" class="flex flex-col xl:flex-row xl:px-6 xl:py-3 bg-white text-left text-sm text-gray justify-between items-center hover:bg-gray-100 border border-gray-200 xl:border-b xl:border-gray-50 xl:border-l-0 xl:border-t-0 xl:border-r-0 xl:items-start">

              <div class="flex flex-row w-full items-center xl:pl-2 xl:w-1/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent xl:text-base items-stretch">
                <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
                  ID
                </div>
                <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-center xl:pl-1.5 text-sm xl:pt-1">
                  {{ user.id }} &nbsp;
                </div>
              </div>

              <div class="flex flex-row w-full items-center xl:w-2/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent xl:text-base xl:px-1">
                <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
                  Name
                </div>
                <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-center xl:text-left">
                  {{ user.name }}
                </div>
              </div>

              <div class="flex flex-row w-full items-center xl:w-2/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent xl:text-base xl:px-1">
                <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
                  Email
                </div>
                <div class="break-all flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-center xl:text-left">
                  {{ user.email }}
                </div>
              </div>

              <div class="flex flex-row w-full items-center xl:w-2/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent xl:text-base xl:px-1">
                <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
                  Signed Up
                </div>
                <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-center xl:text-left">
                  {{ formatDate(user.created_at) }}
                </div>
              </div>

              <div class="flex flex-row w-full items-center xl:w-1/12 bg-gray-100 xl:bg-transparent justify-end xl:text-base">
                <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
                  Actions
                </div>
                <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-auto px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-center text-gray-500">
                  <user-search-crud-button  :user="user" :key="user.id" :can-support-campaign="canSupportCampaign" ></user-search-crud-button>
                </div>
              </div>
            </div>

          </div>
        </div>

        <button v-if="this.next_page_url" @click="loadMore" type="button" id="loadMore" class="mx-auto items-center px-6 py-3 border border-transparent text-base font-medium shadow-sm text-white bg-green-500 hover:bg-green-700 focus:outline-none  focus:ring-green-200">
          Load More ({{usersData.to}} of {{usersData.total}})
        </button>

      </div>
    </div>

    <transition v-if="openFilterModal"
                enter-class="transition ease-out duration-100 transform"
                enter-active-class="opacity-0"
                enter-to-class="opacity-100"
                leave-class="transition ease-in duration-200 transform"
                leave-active-class="opacity-100"
                leave-to-class="opacity-0"
    >
      <div  class="fixed z-50 inset-0 overflow-y-auto"  id="user-search-modal">
        <div class="flex items-start justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">

          <div class="fixed inset-0 transition-opacity" aria-hidden="true">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

          <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle xl:max-w-lg w-full sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
            <div class="sm:flex sm:items-start">
              <div class="text-center sm:mt-0 sm:text-left w-full">
                <div class="flex justify-between items-center pb-3">
                  <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                    New User
                  </h3>
                  <div @click="openFilterModal = false" class="modal-close cursor-pointer z-50" id="close-user-modal">
                    <svg  class="fill-current text-black" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path></svg>
                  </div>
                </div>
                <div class="my-3">

                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                    <label for="user_id" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      Name
                    </label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                      <input v-model="addForm.name" type="text" name="user_name" id="user_id" autocomplete="" class="max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300">
                    </div>
                  </div>

                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                    <label for="user_email" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      Email
                    </label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                      <input v-model="addForm.email" type="text"  id="user_email" class="max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300">
                    </div>
                  </div>

                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                    <label for="user_address" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      Address
                    </label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                      <input v-model="addForm.address" type="text"  id="user_address" class="max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300">
                    </div>
                  </div>

                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                    <label for="user_city" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      City
                    </label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                      <input v-model="addForm.city" type="text"  id="user_city" class="max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300">
                    </div>
                  </div>

                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                    <label for="state" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      State
                    </label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                      <select id="state"  v-model="addForm.state" class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                        <option value=""></option>
                        <option value="AL">Alabama</option>
                        <option value="AK">Alaska</option>
                        <option value="AS">American Samoa</option>
                        <option value="AZ">Arizona</option>
                        <option value="AR">Arkansas</option>
                        <option value="CA">California</option>
                        <option value="CO">Colorado</option>
                        <option value="CT">Connecticut</option>
                        <option value="DE">Delaware</option>
                        <option value="DC">District of Columbia</option>
                        <option value="FM">Federated States of Micronesia</option>
                        <option value="FL">Florida</option>
                        <option value="GA">Georgia</option>
                        <option value="GU">Guam</option>
                        <option value="HI">Hawaii</option>
                        <option value="ID">Idaho</option>
                        <option value="IL">Illinois</option>
                        <option value="IN">Indiana</option>
                        <option value="IA">Iowa</option>
                        <option value="KS">Kansas</option>
                        <option value="KY">Kentucky</option>
                        <option value="LA">Louisiana</option>
                        <option value="ME">Maine</option>
                        <option value="MH">Marshall Islands</option>
                        <option value="MD">Maryland</option>
                        <option value="MA">Massachusetts</option>
                        <option value="MI">Michigan</option>
                        <option value="MN">Minnesota</option>
                        <option value="MS">Mississippi</option>
                        <option value="MO">Missouri</option>
                        <option value="MT">Montana</option>
                        <option value="NE">Nebraska</option>
                        <option value="NV">Nevada</option>
                        <option value="NH">New Hampshire</option>
                        <option value="NJ">New Jersey</option>
                        <option value="NM">New Mexico</option>
                        <option value="NY">New York</option>
                        <option value="NC">North Carolina</option>
                        <option value="ND">North Dakota</option>
                        <option value="MP">Northern Mariana Islands</option>
                        <option value="OH" selected="selected">Ohio</option>
                        <option value="OK">Oklahoma</option>
                        <option value="OR">Oregon</option>
                        <option value="PW">Palau</option>
                        <option value="PA">Pennsylvania</option>
                        <option value="PR">Puerto Rico</option>
                        <option value="RI">Rhode Island</option>
                        <option value="SC">South Carolina</option>
                        <option value="SD">South Dakota</option>
                        <option value="TN">Tennessee</option>
                        <option value="TX">Texas</option>
                        <option value="UT">Utah</option>
                        <option value="VT">Vermont</option>
                        <option value="VI">Virgin Islands</option>
                        <option value="VA">Virginia</option>
                        <option value="WA">Washington</option>
                        <option value="WV">West Virginia</option>
                        <option value="WI">Wisconsin</option>
                        <option value="WY">Wyoming</option>
                      </select>
                    </div>
                  </div>

                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                    <label for="user_city" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      Zip
                    </label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                      <input v-model="addForm.zip" type="text"  id="user_zip" class="max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300">
                    </div>
                  </div>

                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                    <label for="user_address" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      Phone
                    </label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                      <input v-model="addForm.phone" type="text"  id="user_phone" class="max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300">
                    </div>
                  </div>


                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                    <label for="user_role" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      Role
                    </label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                      <select v-model="addForm.role" id="user_role" name="user_role" autocomplete="" class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                        <option value=""></option>
                        <option value="member">Member</option>
                        <option value="admin">Admin</option>
                      </select>
                    </div>
                  </div>


                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                    <label for="user_address" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      Password
                    </label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                      <input v-model="addForm.password" type="text"  id="user_password" class="max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300">
                    </div>
                  </div>

                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                    <label for="user_address" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                      Password Confirmation
                    </label>
                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                      <input v-model="addForm.passwordConfirmation" type="text"  id="user_password2" class="max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300">
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
              <button @click="addUser" class="w-full inline-flex justify-center border border-transparent shadow-sm px-4 py-2 bg-blue-500 text-base font-medium text-white hover:bg-blue-700 focus:outline-none  focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm">
                Add
              </button>
            </div>
          </div>
        </div>
      </div>

    </transition>

  </div>
</template>

<script>
import { buildHttpErrorNotification } from '../../http-error-notifier'
import moment from "moment";
import flatPickr from 'vue-flatpickr-component';
import 'floating-vue/dist/style.css'

export default {
  props: {
    allUsers: {},
    user: {},
    // Mirrors User::canSupportCampaign() server-side; supplied by the blade.
    canSupportCampaign: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    flatPickr
  },
  created() {
    this.emitter.on('user-updated',  this.search);
  },
  data() {
    return {
      options: {
        classes: ''
      },
      usersData: this.allUsers,
      users: this.allUsers?.data,
      isOpen: false,
      openFilterModal: false,

      next_page_url: this.allUsers?.next_page_url ?  '/admin/user-search-with-term?page=2' : '',
      searchTerm: '',
      addForm: {
        name: null,
        email: null,
        address: null,
        city: null,
        zip: null,
        state: null,
        phone: null,
        password: null,
        passwordConfirmation: null,
        role: '',
      },
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format('MM-DD-YYYY')
    },
    search() {
      axios.get('/admin/user-search-with-term?search_term='+this.searchTerm)
          .then(response => {
            this.users =   response.data.data
            this.usersData =   response.data
            this.next_page_url = response.data.next_page_url
            this.isLoading = false
            this.isLoadingMore = false

            this.openFilterModal = false
          })
    },
    loadMore() {
      if (this.next_page_url) {
        axios.get(this.next_page_url+'&search_term='+this.searchTerm)
            .then(response => {
              this.usersData =   response.data

              response.data.data.map((value, key) => {
                this.users.push(value)
              })
              this.next_page_url = response.data.next_page_url
              this.isLoading = false
              this.isLoadingMore = false

              if (this.next_page_url) {
                // VueScrollTo.scrollTo('#loadMore', 1300)
              }
            })
      } else {
        this.isLoading = false
        this.isLoadingMore = false
      }
    },
    addUser() {

      if (!this.addForm.name) {
        this.$notify({
          text: 'Name is required',
          type: 'error',
        })
        return
      }
      if (!this.addForm.email) {
        this.$notify({
          text: 'Email is required',
          type: 'error',
        })
        return
      }
      if (!this.addForm.password) {
        this.$notify({
          text: 'Password is required',
          type: 'error',
        })
        return
      }

      if (this.addForm.password !== this.addForm.passwordConfirmation) {
        this.$notify({
          text: 'Password does not match',
          type: 'error',
        })
        return
      }

      axios.post('/admin/user-search-add-user', this.addForm).then((response) => {
        if (response.data.message == 'error') {
          this.$notify({text: response.data.comment, type: 'error', })
          return
        }
        this.$notify({text: 'New user added',type: 'success', })

        this.search()

        this.openFilterModal = false
      })
      .catch(error => {
        // Without this the modal just sits there on a 403/419/500 and the
        // admin has no way to tell a denied request from a dead button.
        this.$notify(buildHttpErrorNotification(error))
      });
    },
  }
}
</script>

<style scoped>

</style>
